import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenuHr = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M18 3H6C3.79 3 2 4.78 2 6.97V17.03C2 19.22 3.79 21 6 21H18C20.21 21 22 19.22 22 17.03V6.97C22 4.78 20.21 3 18 3Z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 8.75H14C13.59 8.75 13.25 8.41 13.25 8C13.25 7.59 13.59 7.25 14 7.25H19C19.41 7.25 19.75 7.59 19.75 8C19.75 8.41 19.41 8.75 19 8.75Z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 12.75H15C14.59 12.75 14.25 12.41 14.25 12C14.25 11.59 14.59 11.25 15 11.25H19C19.41 11.25 19.75 11.59 19.75 12C19.75 12.41 19.41 12.75 19 12.75Z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 16.75H17C16.59 16.75 16.25 16.41 16.25 16C16.25 15.59 16.59 15.25 17 15.25H19C19.41 15.25 19.75 15.59 19.75 16C19.75 16.41 19.41 16.75 19 16.75Z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.49994 11.7899C9.77572 11.7899 10.8099 10.7557 10.8099 9.47992C10.8099 8.20414 9.77572 7.16992 8.49994 7.16992C7.22416 7.16992 6.18994 8.20414 6.18994 9.47992C6.18994 10.7557 7.22416 11.7899 8.49994 11.7899Z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.30003 13.1098C8.77003 13.0598 8.22003 13.0598 7.69003 13.1098C6.01003 13.2698 4.66003 14.5998 4.50003 16.2798C4.49003 16.4198 4.53003 16.5598 4.63003 16.6598C4.73003 16.7598 4.86003 16.8298 5.00003 16.8298H12C12.14 16.8298 12.28 16.7698 12.37 16.6698C12.46 16.5698 12.51 16.4298 12.5 16.2898C12.33 14.5998 10.99 13.2698 9.30003 13.1098Z",
			fill: "#fff"
		})
	]
});
export default SvgMenuHr;
